export const VIEW_STUDENT_PER_STATUS = "/admin/form/";
export const VIEW_USER_PER_ID = "/admin/form/user/";
export const UPDATE_USER_STATUS = "/admin/form/status";
export const UPDATE_USER_DETAILS = "/admin/user";
export const GET_DROPDOWN = "/admin/form/";

export const ADD_RESCHEDULE = "/admin/exam/reschedule";

export const UPDATE_RE_REGISTER = "/admin/form/reregister"


export const GET_SERVICE_CADRE = "/admin/form/service-cadre";
export const GET_REJECTION_REASONS = "/admin/form/rejection-reasons";
export const GET_SERVICE = "admin/form/service";
export const GET_DEPARTMENT = "/admin/form/departments"
export const GET_CATEGORY = "/admin/form/category";
export const GET_RESULT = "/admin/form/payment/";

